
  import { Vue, Options } from "vue-class-component";
  import ResidentialContactForm from "@/components/forms/ResidentialContactForm.vue";
  import Spinner from "@/components/misc/Spinner.vue";

  @Options({
    components: {
      ResidentialContactForm,
      Spinner
    },
    emits: ['loading']
  })

  export default class ProductRangeView extends Vue { }
